import type {Image} from '@/api/pageService/client';

import {Breakpoint} from '@travel-frontend/core';
import {Stack} from '@travel-frontend/ui-components';

import {resolveImageUrl} from '@/modules/common/queries/pageService/utils';

type Props = {
  imageMedium?: Image;
  imageSmall?: Image;
  imageLarge?: Image;
};

export const TrustBadge: React.FunctionComponent<Props> = ({
  imageMedium,
  imageSmall,
  imageLarge,
}) => {
  return (
    <Stack alignItems="center">
      <Breakpoint matches={['sm', 'xs']}>
        <img src={resolveImageUrl(imageSmall)} alt="" />
      </Breakpoint>
      <Breakpoint matches={['md']}>
        <img src={resolveImageUrl(imageMedium)} alt="" />
      </Breakpoint>
      <Breakpoint matches={['lg', 'xl']}>
        <img src={resolveImageUrl(imageLarge)} alt="" />
      </Breakpoint>
    </Stack>
  );
};
